<template>
  <router-view />
</template>

<script>
export default {
  name: 'App'
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

html,
body,
#app {
  height: 100%;
  overflow: hidden;
}

body {
  font-family: var(--mp-font);
  background: var(--mp-bg);
  color: var(--mp-text);
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
}

/* Shared page primitives */
.mp-page {
  display: flex;
  flex-direction: column;
  gap: 18px;
  max-width: 1460px;
}

.mp-page.mp-page--wide {
  max-width: none;
}

.mp-panel {
  background: var(--mp-surface);
  border: 1px solid var(--mp-border);
  border-radius: var(--mp-radius-lg);
  box-shadow: var(--mp-shadow);
}

.mp-panel-header {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 12px;
  padding: 22px 22px 0;
}

.mp-panel-title {
  font-size: 14px;
  font-weight: 700;
  color: var(--mp-text);
  letter-spacing: -0.02em;
}

.mp-panel-body {
  padding: 16px 22px 22px;
}

.mp-muted {
  color: var(--mp-text-muted);
  font-size: 11px;
}

.mp-eyebrow {
  font-family: var(--mp-font-mono);
  font-size: 10px;
  letter-spacing: 1.5px;
  color: var(--mp-text-muted);
  margin: 0 0 8px;
  text-transform: uppercase;
}

.mp-eyebrow .live {
  color: var(--mp-success);
}

/* —— 全站视觉细节：Element Plus 组件与设计令牌对齐 —— */
.el-table th.el-table__cell {
  background: #fafbfd;
  color: var(--mp-text-muted);
  font-size: 12px;
  font-weight: 650;
}

.el-table {
  --el-table-border-color: var(--mp-border);
  --el-table-row-hover-bg-color: #f7f9fd;
}

.el-dialog {
  border-radius: 14px;
}

.el-drawer__header {
  margin-bottom: 0;
  padding: 16px 20px;
  border-bottom: 1px solid var(--mp-border);
  color: var(--mp-text);
  font-weight: 700;
}

.el-tag {
  border-radius: 6px;
}

.el-empty__description p {
  color: var(--mp-text-muted);
}

/* 键盘操作时的焦点可见 */
a:focus-visible,
button:focus-visible,
[role='tab']:focus-visible {
  outline: 2px solid var(--mp-accent);
  outline-offset: 2px;
}

/* 细滚动条 */
* {
  scrollbar-width: thin;
  scrollbar-color: #d5dbe6 transparent;
}

*::-webkit-scrollbar {
  width: 8px;
  height: 8px;
}

*::-webkit-scrollbar-thumb {
  background: #d5dbe6;
  border-radius: 8px;
}

*::-webkit-scrollbar-track {
  background: transparent;
}

@media (prefers-reduced-motion: reduce) {
  *,
  *::before,
  *::after {
    animation-duration: 0.01ms !important;
    transition-duration: 0.01ms !important;
  }
}
</style>
